import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Stripe_customer } from '../models/accounting/banking/stripe_customer';
import { Stripe_credit_card } from '../models/accounting/banking/stripe_credit_card';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class StripePaymentCardService {

  constructor(private http: HttpClient) { }

  get_list(competition_organizer_id: string): Promise<Stripe_customer[]> {
    return this.getListWithRest("/competition_organizer_id/" + competition_organizer_id);
  }

  private getListWithRest(rest_url: string) : Promise<Stripe_customer[]> {
    return new Promise((resolve, reject) => {
    return this.http.get(AppSettings.API_ENDPOINT + 'accounting/banking/stripe_customers' + rest_url).subscribe((response:any) => {
      if(response.type == 'stripe_customers' && response.data){
        resolve(response.data);
      } else {
        reject(response);
      }

    },
      error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
  });
  }

    createCustomer(customer: Stripe_customer): Promise<Stripe_customer> {
      let post_data = {
          data: {
            type: 'stripe_customer',
            attributes: customer
            }
        };

        return new Promise((resolve, reject) => {

              return this.http.post(AppSettings.API_ENDPOINT + 'accounting/banking/stripe_customers',
                  post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                       if(response.data && response.type=='sms_stripe_customer') {
                           resolve(response.data);
                         }  else {
                           if(response.text){
                             reject(response.text);
                           } else {
                            reject(response);
                          }
                         }

                  }, error => {
                    if(error instanceof HttpErrorResponse){
                      reject(error.error);
                    } else {
                      reject(error.data ? error.data : error);
                    }
               });
             });
    }


  createCard(card: any): Promise<Stripe_credit_card> {

    console.log(card);

    let post_data = {
        data: {
          type: 'stripe_credit_card_request',
          attributes: card
          }
      };

      return new Promise((resolve, reject) => {

            return this.http.post(AppSettings.API_ENDPOINT + 'accounting/banking/stripe_credit_cards',
                post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && response.type=='sms_stripe_credit_card') {
                         resolve(response.data);
                       }  else {
                         if(response.text){
                           reject(response.text);
                         } else {
                          reject(response);
                        }
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error.data ? error.data : error);
                  }
             });
           });
  }

    hideCustomer(customer: Stripe_customer): Promise<boolean> {
      let put_data = {
          data: {
            type: 'customer_hide_request',
            attributes: { system_customer_id: customer.system_customer_id }
            }
        };

        return new Promise((resolve, reject) => {

              return this.http.put(AppSettings.API_ENDPOINT + 'accounting/banking/stripe_customers',
                  put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                       if(response.data && response.type=='customer_hide_response') {
                          resolve(response.data);
                         }  else {
                          if(response.text){
                            reject(response.text);
                          } else {
                            reject(response);
                          }
                         }

                  }, error => {
                    if(error instanceof HttpErrorResponse){
                      reject(error.error);
                    } else {
                      reject(error);
                    }
                  });
              });
    }

  hideCard(card: Stripe_credit_card): Promise<boolean> {
    let put_data = {
        data: {
          type: 'card_hide_request',
          attributes: { id: card.system_payment_method_id }
          }
      };

      return new Promise((resolve, reject) => {

            return this.http.put(AppSettings.API_ENDPOINT + 'accounting/banking/stripe_credit_cards',
                put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && response.type=='card_hide_response') {
                         resolve(response.data);
                       }  else {
                         if(response.text){
                           reject(response.text);
                         } else {
                          reject(response);
                        }
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error);
                  }
                });
            });
  }

}
